<!-- 客户档案>新增>发货地址 -->
<template>
  <div id="shippingAddr">
    <div class="btns">
      <el-button
        class="btnItems"
        v-if="hasPermiss('admin:customer:addCustomerAddr')"
        @click="add()"
        >添加</el-button
      >
      <el-button
        class="btnItems"
        v-if="hasPermiss('admin:customer:udpateCustomerAddr')"
        @click="modify()"
        >编辑</el-button
      >
      <el-button
        class="btnItems"
        v-if="hasPermiss('admin:customer:delCustomerAddr')"
        @click="delBtns()"
        >删除</el-button
      >
    </div>
    <!-- 查询条件 -->
    <div class="dddform">
      <el-form label-position="left" :inline="true">
        <el-form-item class="queryItems" label="联系人:">
          <el-input
            clearable
            v-model="queryData.personnelName"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item class="queryItems" label="电话:">
          <el-input
            clearable
            v-model="queryData.tel"
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button class="glo_btnItems glo_bgcMainColor" @click="queryINit()"
            >查询</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <div class="tablebox">
      <div class="glo_Table">
        <el-table
          :height="tableHeight"
          header-align="center"
          ref="mytable"
          @row-click="rowclick"
          :data="tableData"
          border
          stripe
          :highlight-current-row="true"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            fixed="left"
            align="center"
            label="序号"
            type="index"
            width="60"
          />

          <el-table-column
            fixed="left"
            align="center"
            type="selection"
            width="60"
          />

          <el-table-column
            v-for="(item, index) in tableHead"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            :show-overflow-tooltip="true"
            :min-width="item.width"
          />
        </el-table>
      </div>
    </div>
    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    />

    <my-dialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="diaCancelBtn"
      @diaConfirmBtn="diaConfirmBtn"
    >
      <div class="addForm">
        <el-form
          :model="formdata"
          ref="addForm"
          v-if="isShowDialog"
          label-width="100px"
          class="dia_form"
          :rules="formRule"
        >
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="地址简称:" prop="addressName">
                <el-input
                  v-model="formdata.addressName"
                  placeholder="请输入"
                  clearable
                />
              </el-form-item>
            </el-col>
            <!-- <el-col :span="12">
              <el-form-item label="地址编号:" prop="aaa">
                <el-input
                  v-model="formdata.aaa"
                  placeholder="请输入"
                  clearable
                />
              </el-form-item>
            </el-col>-->
          </el-row>
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="发货人:" prop="contactName">
                <el-input
                  v-model="formdata.contactName"
                  placeholder="请输入"
                  clearable
                />
                <!-- <el-select v-model="formdata.customerPersonnelId" filterable placeholder="请选择">
                  <el-option v-for="(item, index) in consignorArr" :key="index" :label="item.name" :value="item.personnelId" />
                </el-select> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                label="发货单位/仓库:"
                label-width="120px"
                prop="deptName"
              >
                <el-input
                  v-model="formdata.deptName"
                  placeholder="请输入"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="60">
            <el-col :span="12">
              <el-form-item label="联系电话:" prop="tel">
                <el-input
                  v-model="formdata.tel"
                  placeholder="请输入"
                  clearable
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="手机号:" prop>
                <el-input
                  v-model="formdata.phone"
                  placeholder="请输入"
                  clearable
                />
              </el-form-item>
            </el-col>

            <!-- <el-col :span="12" /> -->
          </el-row>
          <el-row :gutter="10">
            <el-form-item label="省市区:" prop="cityName">
              <el-col :span="8">
                <el-select
                  v-model="formdata.provinceName"
                  @change="changeProvince"
                  placeholder="请选择省"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item, index) in provinceArr"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  />
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select
                  v-model="formdata.cityName"
                  @change="changeCity"
                  placeholder="请选择市"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item, index) in cityArr"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  />
                </el-select>
              </el-col>
              <el-col :span="8">
                <el-select
                  v-model="formdata.areaName"
                  placeholder="请选择区"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item, index) in districtArr"
                    :key="index"
                    :label="item.districtName"
                    :value="item.districtName"
                  />
                </el-select>
              </el-col>
            </el-form-item>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="详细地址:" prop="address">
                <el-input
                  v-model="formdata.address"
                  placeholder="请输入"
                  clearable
                />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-form-item label="备注:" prop="remarks">
                <el-input type="textarea" rows="2" v-model="formdata.remarks" />
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="默认收件员:" prop="pickUpUserId">
                <el-select
                  v-model="formdata.pickUpUserId"
                  placeholder="请选择区"
                  clearable
                  filterable
                >
                  <el-option
                    v-for="(item, index) in users"
                    :key="index"
                    :label="item.userName"
                    :value="item.userId"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="默认发货地址:" prop="isDefault">
                <el-checkbox v-model="formdata.isDefault">默认</el-checkbox>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </my-dialog>
  </div>
</template>
      <script >
import myDialog from "@/components/Dialog.vue";
import paging from "@/components/pagings.vue"; //分页组件
export default {
  components: {
    myDialog,
    paging,
  },
  props: {
    common: {
      type: Object,
    },
  },
  data() {
    return {
      customerId: this.common.customerId,
      provinceArr: null,
      cityArr: null,
      districtArr: null,
      consignorArr: [],
      users: [],
      tableHeight: "65vh", //  表格高度
      tableData: [],
      tableHead: [
        {
          name: "地址编号",
          field: "number",
          width: "210",
        },
        {
          name: "地址简称",
          field: "addressName",
          width: "120",
        },
        {
          name: "默认地址",
          field: "isDefaultShow",
          width: "90",
        },
        {
          name: "发货单位/仓库",
          field: "deptName",
          width: "120",
        },
        {
          name: "发货人",
          field: "contactsName",
          width: "120",
        },
        {
          name: "联系人",
          field: "personnelName",
          width: "120",
        },
        {
          name: "身份证号",
          field: "idNumber",
          width: "180",
        },
        {
          name: "手机号",
          field: "phone",
          width: "120",
        },
        {
          name: "联系电话",
          field: "tel",
          width: "120",
        },
        {
          name: "省份",
          field: "provinceName",
          width: "120",
        },
        {
          name: "城市",
          field: "cityName",
          width: "120",
        },
        {
          name: "区县",
          field: "areaName",
          width: "160",
        },
        {
          name: "详细地址",
          field: "address",
          width: "120",
        },

        {
          name: "备注",
          field: "remarks",
          width: "120",
        },
      ],
      selectTableData: [],
      pageStart: 1,
      pageCount: 0,
      pageTotal: this.$COMMON.pageTotals,
      diaWidth: "50%",
      dialogTitle: "编辑地址",
      isShowDialog: false,
      formdata: { isDefault: false, areaName: "" },
      defaultFormData: {
        customerId: null,
        address: null,
        addressName: null,
        areaName: null,
        cityName: null,
        customerPersonnelId: null,
        contactName: null,
        provinceName: null,
        tel: null,
        addressType: null,
        deptName: null,
        phone: null,
        remarks: null,
        isDefault: false,
        pickUpUserId: null,
      },
      formRule: {
        contactName: [{ required: true, message: "请输入", trigger: "blur" }],
        phone: [
          { required: true, message: "请输入正确的手机号", trigger: "blur" },
        ],
        tel: [
          { required: true, message: "请输入正确的联系电话", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        cityName: [{ required: true, message: "请选择", trigger: "change" }],
      },
      queryData: {
        personnelName: "",
        tel: "",
      },
    };
  },
  created() {
    this.GetData();
    this.getParentName("中华人民共和国"); //默认查到各省
    this.getUserList();
  },
  methods: {
    // 获取用户列表
    async getUserList() {
      const users = await this.$API.runList("admin_user_list");
      this.users = users;
    },
    // 选择省(收货地址)
    changeProvince(e) {
      this.formdata.cityName = "";
      this.formdata.areaName = "";
      this.cityArr = [];
      this.districtArr = [];
      if (e) {
        this.getCityName(e);
      }
    },
    // 选择市(收货)
    changeCity(e) {
      this.formdata.areaName = "";
      this.districtArr = [];
      if (e) {
        this.getAreaName(e);
      }
    },
    // 默认查省级
    getParentName(e) {
      let p = {
        pageStart: 1,
        pageTotal: 100,
        parentName: e,
      };
      this.$API.wtl_getDistrictList(p).then((res) => {
        this.provinceArr = res.data.result.data || [];
      });
    },
    // 获取市
    getCityName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.cityArr = res.data.result.data || [];
        });
    },
    // 获取区
    getAreaName(e) {
      if (!e) {
        return false;
      }
      this.$API
        .wtl_getDistrictList({
          pageStart: 1,
          pageTotal: 100,
          parentName: e,
        })
        .then((res) => {
          this.districtArr = res.data.result.data || [];
        });
    },
    queryINit() {
      this.queryData.pageStart = 1;
      this.GetData();
    },
    // 获取客户地址列表
    GetData() {
      let queryData = this.queryData;
      queryData.pageStart = this.pageStart;
      queryData.pageTotal = this.pageTotal;
      queryData.customerId = this.customerId;
      queryData.addressType = "ji_jian:address_type";
      this.$API.CustomerAddrList(queryData).then((res) => {
        if (res.data.status === "success") {
          this.className = res.data.result?.className || "";
          this.tableData = res.data.result?.data || [];
          this.pageCount = res.data.result?.pageCount || 0;
        } else {
          this.$message.error(`${res.data.message}---客户地址列表`);
        }
      });
    },

    // 获取发货人
    GetPersonnelList() {
      let requestParam = {
        customerId: this.customerId,
        personnelType: "fa_jian:personnel_type",
      };
      this.$API.PersonnelList(requestParam).then((res) => {
        if (res.data.status === "success") {
          this.consignorArr = res.data.result?.data || [];
        }
      });
    },
    // 删除
    delBtns(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length < 1) {
        this.$message.error("请至少选择一条数据进行操作");
        return false;
      } else {
        this.$confirm("确定要删除所选数据吗?", "提示:")
          .then((res) => {
            let delReq = {
              addrIds: new Array(),
            };
            this.selectTableData.map(function (val, i) {
              delReq.addrIds.push(val.addrId);
            });
            this.$API.delCustomerAddr(delReq).then((res) => {
              if (res.data.status === "success") {
                try {
                  let num = 0;
                  let arr = this.tableConfig.tableData;
                  if (delReq.addrIds.length > 2) {
                    delReq.addrIds.map(function (v, i) {
                      num = arr.findIndex((element) => element.addrId == v);
                      arr.splice(num, 1);
                    });
                  } else {
                    num = arr.findIndex(
                      (element) => element.addrId == delReq.addrIds[0]
                    );
                    arr.splice(num, 1);
                  }
                } catch {
                  this.GetData();
                }
                this.$message.success("已删除");
              }
            });
          })
          .catch((err) => {
            if (data) this.selectTableData.length = 0;
          });
      }
    },
    modify(data) {
      if (data) this.selectTableData = [data];
      if (this.selectTableData.length !== 1) {
        this.$message.error("请选择一条数据进行操作");
        return false;
      } else {
        // this.GetPersonnelList();
        this.getUserList();
        let curs = this.selectTableData[0];
        curs.isDefault = Boolean(curs.isDefault);
        if (curs.provinceName) {
          this.changeProvince(curs.provinceName);
        }
        if (curs.cityName) {
          this.changeCity(curs.cityName);
        }

        this.formdata = curs;
        this.formdata.contactName = curs.contactsName;
        this.isShowDialog = true;
      }
    },
    add() {
      this.formdata.customerId = this.customerId;
      // this.GetPersonnelList();
      this.isShowDialog = true;
    },
    handleSizeChange(val) {
      this.pageTotal = val;
      this.GetData();
    },
    handleCurrentChange(val) {
      this.pageStart = val;
      this.GetData();
    },
    // 表格
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          // 正常提交
          let param = {};
          this.formdata.isDefault = Number(this.formdata.isDefault) || 0;
          for (let key in this.defaultFormData) {
            if (this.formdata[key]) {
              eval("param." + key + "='" + this.formdata[key] + "'");
            } else {
              eval("param." + key + "=''");
            }
          }
          if (this.formdata.addrId) param.addrId = this.formdata.addrId;
          let Arr = ["provinceName", "cityName"];
          for (let i in Arr) {
            let p = Arr[i];
            if (param[p] !== null) {
              param[p] = param[p]?.replace(/[0-9]+/g, "");
            }
          }

          param.addressType = "ji_jian:address_type";
          param.remarks = param.remarks || "";
          param.isDefault = param.isDefault || "0";
          if (param.addrId) {
            // 修改接口
            this.$API.udpateCustomerAddrV5(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.$refs.addForm.resetFields();
                this.GetData();
              }
            });
          } else {
            // 新增接口
            this.$API.addCustomerAddrV5(param).then((res) => {
              if (res.data.status === "success") {
                this.$message.success(res.data.message);
                this.isShowDialog = false;
                this.$refs.addForm.resetFields();
                this.GetData();
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.formdata = {};
      this.isShowDialog = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.handleCloseDia();
    },
  },
};
</script>
<style scoped lang="less">
#shippingAddr {
  margin: 40px 40px;
  .dddform {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .el-form {
      flex: 1;
    }
  }
  .btns {
    flex: 1;
    .btnItems {
      border: 1px solid #606266;
      background-color: #fff;
      color: #333;
      padding: 5px 20px;
      margin-left: 10px;
      margin-bottom: 8px;
    }

    .el-button:hover {
      border: 1px solid #ef7c0a;
      color: #ef7c0a;
    }
  }
  .addForm {
    margin: 10px 40px;
  }
  .dia_form {
    .el-form-item {
      margin-bottom: 0px;
      min-width: 260px;
    }
  }
}
</style>
      